import { connect } from "react-redux";
import HtmlHeader from "./HtmlHeader";
import { getViewport } from "../../state/modules/layout";
import { isFeatureActive } from "../../state/modules/features";

const mapStateToProps = state => ({
  viewport: getViewport(state),
  useContentAPIGlobalBanner: !!isFeatureActive(
    state,
    "stc-global-banner-content-api"
  )
});

export default connect(mapStateToProps)(HtmlHeader);



// WEBPACK FOOTER //
// ./template/components/HtmlHeader/index.js